import React, { Component } from 'react';
import DocumentUpload from './DocumentUpload';

export class CreateDocument extends Component {
    static displayName = CreateDocument.name;

    render() {
        return (
            <DocumentUpload documentId='0' formType='Create' />  
        );
    }
}